import axiosInstance from "../api/axiosInstance";
import publicAxios from "../api/publicAxios";

const ok = (r) => ({ status: r.status, data: r.data });
const err = (e) => ({ status: e.response?.status || 500, message: e.response?.data?.message || "Failed" });

// Public — no auth required
export const fetchClientGdCategories = () =>
  publicAxios.get("/client/gd/categories").then(ok).catch(err);

export const fetchClientGdTopics = (params) =>
  publicAxios.get("/client/gd/topics", { params }).then(ok).catch(err);

export const fetchClientGdTopicById = (id) =>
  publicAxios.get(`/client/gd/topics/${id}`).then(ok).catch(err);

export const fetchClientGdComments = (topicId, params) =>
  publicAxios.get(`/client/gd/topics/${topicId}/comments`, { params }).then(ok).catch(err);

// Auth required — posting comments
export const postClientGdComment = (topicId, commentText) =>
  axiosInstance.post(`/client/gd/topics/${topicId}/comments`, { commentText }).then(ok).catch(err);

export const replyClientGdComment = (topicId, commentId, commentText) =>
  axiosInstance.post(`/client/gd/topics/${topicId}/comments/${commentId}/reply`, { commentText }).then(ok).catch(err);
